import { render, staticRenderFns } from "./UrlMigrationNotification.vue?vue&type=template&id=5cdec436&scoped=true"
import script from "./UrlMigrationNotification.vue?vue&type=script&lang=js"
export * from "./UrlMigrationNotification.vue?vue&type=script&lang=js"
import style0 from "./UrlMigrationNotification.vue?vue&type=style&index=0&id=5cdec436&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdec436",
  null
  
)

export default component.exports